export const PROMO_CODE = 'code';
export const BONUS_ID = 'bonus';
